import NewInputField from "./NewInputField";
import { ReactComponent as AddIcon } from "../../../assets/icons/add.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";

const RepeatableInputField = ({
  id,
  label,
  required = false,
  values = [""],
  onChange,
  placeholder = "",
}) => {
  const rows = Array.isArray(values) && values.length ? values : [""];
  const updateRow = (index, value) =>
    onChange(rows.map((row, rowIndex) => (rowIndex === index ? value : row)));
  const addRow = () => onChange([...rows, ""]);
  const removeRow = (index) => {
    const next = rows.filter((_, rowIndex) => rowIndex !== index);
    onChange(next.length ? next : [""]);
  };

  return (
    <div className="fit-column gap-xs">
      <div className="FP_Content text-black">
        {label}
        {required && <span className="text-error"> *</span>}
      </div>
      {rows.map((value, index) => (
        <div className="row gap-s align-center" key={`${id}-${index}`}>
          <div className="flex-1">
            <NewInputField
              id={`${id}-${index}`}
              value={value}
              placeholder={placeholder}
              onChange={(event) => updateRow(index, event.target.value)}
            />
          </div>
          {index === 0 ? (
            <button
              type="button"
              className="ds-repeatable-input-button"
              onClick={addRow}
              aria-label={`Add another ${label}`}
            >
              <AddIcon />
            </button>
          ) : (
            <button
              type="button"
              className="ds-repeatable-input-button"
              onClick={() => removeRow(index)}
              aria-label={`Remove ${label} ${index + 1}`}
            >
              <DeleteIcon />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default RepeatableInputField;
